import {
  startToolOperation,
  type ToolAnalyticsContext,
  type ToolOperation,
  type ToolOutcome,
} from '@saas-pages/shared/public/runtime'

const CONTEXT = {
  app: 'txtify',
  domain: 'txtify.ru',
  route: '/krasivyy-tekst',
  utility: 'fancy-text',
  processingMode: 'local',
} as const satisfies Omit<ToolAnalyticsContext, 'outcome'>

export function startFancyTextCopy(outcome: ToolOutcome): ToolOperation {
  return startToolOperation({ ...CONTEXT, outcome })
}
